import { ca } from '@cian/analytics';

interface ITrackGoToReviewsPageArgs {
  objectId: number;
  rating: number;
  reviewsCount: number;
}

export const trackGoToReviewsPage = ({ objectId, rating, reviewsCount }: ITrackGoToReviewsPageArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'Click_sopr',
    label: 'All_Reviews',
    page: { pageType: 'Card', siteType: 'desktop' },
    products: [{ id: objectId, offerType: 'offer' }],
    extra: { rating, reviewsCount },
  });
};
